/** Step in the email OTP sign-in flow. */
export type OtpStep = "email" | "name" | "otp";

/** Social SSO provider supported on the login screen. */
export type SsoProvider = "google" | "microsoft";

/**
 * Seconds the user must wait between OTP resend requests. The server-side
 * `emailOTP` plugin has its own per-route rate limit, but a UI cooldown
 * gives clearer feedback than a 429 and prevents accidental double-sends
 * from impatient users.
 */
export const OTP_RESEND_COOLDOWN_SECONDS = 60;
